import { transformText } from "./textUtils";
import translationsFile from "@/resourses/Translations";
import UseStoreHandler from "./handlers/UseStoreHandler";

export function getAllTranslations() {
    return translationsFile;
}

export function translate(text = '', textTransform = '', params = {}) {
    if(!text || text == '') {
        return text;
    } 

    const translations = getAllTranslations();
    let langIso = 'pt';

    try {
        langIso = UseStoreHandler.getContextStore().getLang;
    } catch (error) {
        langIso = 'pt';
    }

    let translation = text;

    if (translations[text] != undefined && ![undefined, null, ''].includes(translations[text][langIso])) {
        translation = translations[text][langIso];
    }

    const attrArray = Object.keys(params);
    if (attrArray.length > 0) {
        for (let attr of attrArray) {
            translation = translation.replace(`{${attr}}`, params[attr]);
        }
    }

    return transformText(translation, textTransform);
}